// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__pDNo6","logoBox":"Header_logoBox__rOpwo","menuBox":"Header_menuBox__B2n1n"};